import type { ReactNode } from 'react'
import { cx } from './cx'

export type AlertTone = 'info' | 'success' | 'warning' | 'error'

const TONES: Record<AlertTone, string> = {
  info: 'border-brand-200 bg-brand-50 text-brand-900',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  warning: 'border-accent-200 bg-accent-50 text-accent-900',
  error: 'border-red-200 bg-red-50 text-red-900',
}

/**
 * `role="alert"` on the error and warning tones only.
 *
 * A screen reader interrupting itself to announce a success confirmation the
 * user just caused is noise; a refused action is the case where interrupting is
 * the correct behaviour.
 */
export function Alert({
  tone = 'info',
  title,
  children,
  className,
}: {
  tone?: AlertTone
  title?: ReactNode
  children?: ReactNode
  className?: string
}) {
  return (
    <div
      role={tone === 'error' || tone === 'warning' ? 'alert' : undefined}
      className={cx('rounded-md border px-4 py-3 text-sm', TONES[tone], className)}
    >
      {title && <p className="font-semibold">{title}</p>}
      {children && <div className={title ? 'mt-1' : undefined}>{children}</div>}
    </div>
  )
}
